/* Badge "powered by Fullstack Lab" fisso in basso a destra, presente su tutte
   le viste (login, dashboard, editor). Il logo è inline — importato come testo
   e iniettato — così eredita i colori del tema e non costa una richiesta. */
import logoSvg from "../assets/fslogo.svg?raw";

export function mountBadge(host: HTMLElement = document.body): void {
  if (host.querySelector(".fs-badge")) return; // una sola istanza: gli id del clipPath sono unici
  const badge = document.createElement("a");
  badge.className = "fs-badge";
  badge.href = "https://fullstacklab.it";
  badge.target = "_blank";
  badge.rel = "noopener noreferrer";
  badge.setAttribute("aria-label", "powered by Fullstack Lab");

  const label = document.createElement("span");
  label.className = "fs-badge-label";
  label.textContent = "powered by";

  const logo = document.createElement("span");
  logo.className = "fs-badge-logo";
  logo.innerHTML = logoSvg;
  logo.querySelector("svg")?.setAttribute("aria-hidden", "true");

  badge.append(label, logo);
  host.appendChild(badge);
}
